import { render, staticRenderFns } from "./lottie-animation.vue?vue&type=template&id=4b89f917&"
import script from "./lottie-animation.vue?vue&type=script&lang=js&"
export * from "./lottie-animation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports